import React, { useContext, useEffect, useState } from "react";
import DropDown from "./TPDropDown";
import { useTranslation } from "react-i18next";
import { MenuItem } from "@mui/material";
import { CONSTANT_RECORD_TYPE, SOURCE_TYPE } from "../../constants/loopRecordOptions";
import SourceTypeInboundData from "./SourceTypeComponents/SourceTypeInboundData";
import SourceTypeOutboundData from "./SourceTypeComponents/SourceTypeOutboundData";
import SourceTypeSystemData from "./SourceTypeComponents/SourceTypeSystemData";
import { useSelector } from "react-redux";
import { ParentScreenCtx } from "../../pages/workbench_build/WorkbenchBuild";

const OUTBOUND_ITEMS = CONSTANT_RECORD_TYPE.OUTBOUND_ITEM.map(e => e?.value);
const SYSTEM_ITEMS = [...CONSTANT_RECORD_TYPE.SYSTEM_ITEM.map(e => e?.value), 'CONSTANT'];
export const SourceType = (props) => {
  const { node, disabled, initialSelectCall, isCustomIbTemplate } = props // This Node will be either selected node or trading partner lookup node
  const { valuesHandler, source, includeTrailer, callerComponent } = props;
  const { t } = useTranslation();
  const [sourceType, setSourceType] = useState({ value: t('SELECT'), changedByUser: false });
  const [showInboundTree, setShowInboundTree] = useState(false);
  const inboundDependencyTree = useSelector(
    (state) =>
      state.treeData.outbound.leftTree.inboundDependencyTree
  );
  const parentScreen = useContext(ParentScreenCtx);

  const customValuesHandler = (...args) => {
    Object.keys(args?.[0])?.forEach(e => {
      if ((args?.[0]?.[e] === undefined || args?.[0]?.[e] === null)) delete args?.[0]?.[e];
    })
    valuesHandler(...args)
  }
  let sourceTypeDropdown = props?.hideOutboundOption
    ? SOURCE_TYPE.filter((e, index) => e.value !== "OUTBOUND_ITEM")
    : [...SOURCE_TYPE];
  const sourceTypeOptions = sourceTypeDropdown.map((ele, index) => {
    return (
      <MenuItem key={index} value={ele.value}>
        {ele.title}
      </MenuItem>
    );
  });


  const sourceTypeHandler = (e) => {
    const { value } = e.target;
    setSourceType({ value: e.target.value, changedByUser: true });
    if (value === "INBOUND_DATA") setShowInboundTree(true);
    if (value === "OUTBOUND_ITEM") {
      valuesHandler({
        MAPNAME: t("SELECT"),
        RECORD_TYPE: "CUSTOM_DB_FIELD",
      }, "OUTBOUND_ITEM")
    } else if (value === "SYSTEM_ITEM") {
      valuesHandler({
        MAPNAME: t("SELECT"),
        RECORD_TYPE: "SYSTEM_DATA",
      }, "SYSTEM_ITEM")
    } else if (value === t("SELECT")) {
      valuesHandler({
        MAPNAME: "",
        RECORD_TYPE: "",
      }, "NONE")
    }
    if (value === "INBOUND_DATA") {
      valuesHandler({
        MAPNAME: "",
        RECORD_TYPE: "",
      }, "INBOUND_DATA")
    }
  }

  useEffect(() => {
    return () => {
      setSourceType({ value: t('SELECT'), changedByUser: false });
    }
  },[node?.key])

  useEffect(() => {
    if(sourceType.changedByUser) return;
    // console.log("node", node, sourceType);
    if (OUTBOUND_ITEMS?.includes(node?.RECORD_TYPE) || OUTBOUND_ITEMS?.includes(node?.SOURCE_TYPE)) { setSourceType({ value: 'OUTBOUND_ITEM', changedByUser: false }); }
    else if (SYSTEM_ITEMS?.includes(node?.RECORD_TYPE) || SYSTEM_ITEMS?.includes(node?.SOURCE_TYPE)) setSourceType({ value: 'SYSTEM_ITEM', changedByUser: false });
    else if (
      // (node?.PARENT || node?.SOURCE_PARENT) &&
      (node?.MAPNAME || node?.LOOP_SOURCE_NAME) && (node?.RECORD_TYPE || node?.SOURCE_TYPE) || (sourceType.value === "INBOUND_DATA" && sourceType?.changedByUser)) {
      setSourceType({ value: 'INBOUND_DATA', changedByUser: false });
      if (!inboundDependencyTree.templateFound && !isCustomIbTemplate) setSourceType({ value: t("SELECT"), changedByUser: false })
    }
    // else if (sourceType) setSourceType(sourceType);
    else setSourceType({ value: t('SELECT'), changedByUser: false });
  }, [node?.key, node?.SOURCE_TYPE, node?.RECORD_TYPE, inboundDependencyTree.templateFound])

  useEffect(() => {
    if (props.sourceTypeDropdownChange) props.sourceTypeDropdownChange?.(sourceType);
  }, [sourceType])





  return (
    <>
      <DropDown
        disabled={disabled}
        label={t("LBL_SOURCE_TYPE")}
        options={sourceTypeOptions}
        value={sourceType.value || t('SELECT')}
        onChange={sourceTypeHandler}
        style={{ marginBottom: "10px" }}
      />

      {sourceType.value === 'INBOUND_DATA' && <SourceTypeInboundData
        initialSelectCall={initialSelectCall}
        source={source}
        node={node}
        sourceType={sourceType}
        valuesHandler={customValuesHandler}
        allowAllTreeSelection={props?.allowAllTreeSelection}
        showInboundTree={showInboundTree}
        setShowInboundTree={setShowInboundTree}
        setSourceType={setSourceType}
        isCustomIbTemplate={props?.isCustomIbTemplate || false}
        customTreeData={props?.treeData || []}
      />}
      {sourceType.value === 'OUTBOUND_ITEM' && <SourceTypeOutboundData sourceType={sourceType.value} valuesHandler={customValuesHandler} node={node} disabled={props?.disabled} />}
      {sourceType.value === 'SYSTEM_ITEM' && <SourceTypeSystemData sourceType={sourceType.value} valuesHandler={customValuesHandler} node={node} includeTrailer={includeTrailer} callerComponent={callerComponent} disabled={props?.disabled} />}

    </>
  );
};

export default SourceType;
